import {AchievementDAO} from "./AchievementDAO";
import {CONTINUOUS_ACHIEVE_TYPE, ContinuousAchieveDetector} from "./ContinuousAchieveDetector";
import {AchievementCache} from "./AchievementCache";
import {COUNT_ACHIEVE_TYPE, CountAchieveDetector} from "./CountAchieveDetector";
import {AchievedRecord} from "./AchievedRecord";

let instance

export class AchievementManager {
  static getInstance() {
    if (!instance) {
      instance = new AchievementManager()
    }
    return instance
  }

  constructor() {
    this.updateCache()
    this.continusDetector = new ContinuousAchieveDetector(this.cache)
    this.continusDetector.onAchieved = (params) => { this.onAchieved(params) }
    this.countDetector = new CountAchieveDetector(this.cache)
    this.countDetector.onAchieved = (params) => { this.onAchieved(params) }
    this.handlers = []
  }

  updateCache() {
    this.cache = new AchievementCache(AchievementDAO.getInstance().readData())
  }

  addCallback(callback) {
    this.handlers.push(callback)
  }

  getAchievements() {
    return {
      continuous: this.continusDetector.getAchievements(),
      counts: this.countDetector.getAchievements(),
    }
  }

  onAchieved(params) {
    this.handlers.forEach(callback => { callback(new AchievedRecord(params)) })
  }

  check(contentsType, metricName, diff) {
    const today = this.getToday()
    if (metricName === 'time') {
      this.continusDetector.checkContinuousType(today, 'time', diff)
    }

    const key = `${contentsType}-${metricName}`
    if (COUNT_ACHIEVE_TYPE[key]) {
      this.countDetector.checkCountType(key, diff)
    }
    if (CONTINUOUS_ACHIEVE_TYPE[key]) {
      this.continusDetector.checkContinuousType(today, key, diff)
    }

    if (this.cache.isDirty()) {
      AchievementDAO.getInstance().writeData(this.cache.flush())
    }
  }

  setDebugDate(d) {
    this.debugDate = d
  }

  getToday() {
    if (this.debugDate) {
      return this.debugDate
    }
    const d = new Date()
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
  }

  reset() {
    AchievementDAO.getInstance().truncate()
    this.updateCache()
  }
}



// WEBPACK FOOTER //
// ./src/components/common/achievement/AchievementManager.js